class ScrollLock {
  constructor() {
    this.locked = false;
  }

  lock() {
    this.locked = true;
    document.body.classList.add('overflow-clip');
  }

  unlock() {
    this.locked = false;
    document.body.classList.remove('overflow-clip');
  }
}

const scrollLock = new ScrollLock();

export default scrollLock;